import React, { useContext, useEffect } from 'react';
import { FlowContext } from '../../core/flow-engine';
import {
  MFBeaconButton,
  MFBeaconIconButton,
  MFBeaconModal
} from '../Beacon/BeaconComponents';
import styles from './styles.css';
import unlockIcon from '../../images/blue-unlock.svg';
import arrow from '../../images/Icon-Arrow-Right.svg';
import closeBtn from '../../assets/images/Icon-button-close-beacon.svg';
import { meetsSummitIClassEligibility } from '../../flows/shared/summit.testers';
import { dispatchOverlayLoad } from '../../analytics/analytics-helper';
import { modalCloseHandler, modalCloseNextModalHandler } from '../Modal/utils';
import { filterExistingInvestmentsFromNew } from '../../flows/shared/utils';
import { meetsIClassEligibility } from '../../flows/shared/testers';

const displayDivider = (index, funds) => {
  return funds.length > 1 && index !== funds.length - 1;
};

const UpdateToIClassModal = () => {
  const { appState, next, closeNextModal } = useContext(FlowContext);

  const {
    store: { app, chosenInvestments, summitData }
  } = appState;

  const filteredNewInvestments = filterExistingInvestmentsFromNew(
    app?.existingAccounts,
    chosenInvestments
  );

  const iClassEligibleFunds = filteredNewInvestments.filter(
    fund =>
      meetsSummitIClassEligibility(fund, summitData?.assetTierID) ||
      meetsIClassEligibility(fund)
  );

  useEffect(() => {
    // Send analytics the overlay state
    dispatchOverlayLoad('UpdateToIClass');
  }, []);

  const modalTitle = `Update to I Class?`;

  return (
    <>
      <MFBeaconModal scale="jumbo" open removeCloseButton>
        <span className="modal-close-icon">
          <MFBeaconIconButton
            variant="tertiary"
            id="updateToIClassClose"
            data-name="updateToIClassClose"
            onClick={() => {
              modalCloseNextModalHandler(closeNextModal);
              next(chosenInvestments, 'noIClass')();
            }}
            label="close-button">
            <img slot="icon" src={closeBtn} alt="close icon" />
          </MFBeaconIconButton>
        </span>
        <div className="beacon-modal__title">{modalTitle}</div>
        <div
          className={`iclass-contents${
            iClassEligibleFunds.length > 1 ? ' add-margin' : ''
          }`}>
          <p className="beacon-modal__description">
            You qualify for lower cost I Class shares. Expense ratios shown
            below, are as of the most recent prospectus.{' '}
            <a
              className="prospectus-link"
              href="https://www.troweprice.com/personal-investing/funds/mutual-funds/prospectuses-reports.html"
              target="_blank"
              rel="noopener noreferrer">
              View Prospectuses
            </a>
          </p>
          <div className="funds-container">
            {iClassEligibleFunds.map((fund, index) => (
              <>
                <div className="fund-container" key={fund.ticker}>
                  <div className="class-fund">
                    <span className="you-selected">YOU SELECTED</span>
                    <span className="fund-title">
                      {fund.name} ({fund.ticker})
                    </span>
                    <span className="fund-ratio">
                      <span className="fund-ratio-label">
                        Gross Expense Ratio
                      </span>
                      <p className="ration-percentage">
                        {fund.grossExpenseRatio}%
                      </p>
                    </span>
                  </div>
                  <div className="funds-container-image">
                    <img src={arrow} className="arrow-image" alt="Arrow" />
                  </div>
                  <div className="class-fund">
                    <span>
                      <img
                        className="allo-sf-ribbon-icon"
                        src={unlockIcon}
                        alt="Unlocked"
                      />{' '}
                      I CLASS
                    </span>
                    <span className="fund-title">
                      {fund.correspondingFund.name} (
                      {fund.correspondingFund.ticker})
                    </span>
                    <span className="fund-ratio">
                      Gross Expense Ratio
                      <p className="ration-percentage">
                        {fund.correspondingFund.grossExpenseRatio}%
                      </p>
                    </span>
                  </div>
                </div>
                {displayDivider(index, iClassEligibleFunds) && (
                  <hr className="divider" />
                )}
              </>
            ))}
          </div>
        </div>
        <div slot="action-zone" className="iclass-modal-btn-container">
          <MFBeaconButton
            noButtonMargin
            variant="tertiary"
            id="updateToIClassKeepingSelected"
            data-name="updateToIClassKeepingSelected"
            onClick={() => {
              modalCloseNextModalHandler(closeNextModal);
              next(chosenInvestments, 'noIClass')();
            }}
            label="Keep Selected"
          />
          <MFBeaconButton
            noButtonMargin
            variant="primary"
            onClick={() => {
              modalCloseHandler();
              next(chosenInvestments, 'yesIClass')();
            }}
            id="updateFundsToIClass"
            data-name="updateFundsToIClass"
            type="button"
            label={iClassEligibleFunds.length === 1 ? 'Update' : 'Update All'}
          />
        </div>
      </MFBeaconModal>
      <style jsx>{styles}</style>
    </>
  );
};

export default UpdateToIClassModal;
